export default {
  name: "ProxyForm",
  props: {
    priorityContactPassenger: {
      type: Boolean,
      require: false,
      default: false
    },
    passengerMobile: {
      type: String,
      require: false,
      default: ""
    },
    passengerName: {
      type: String,
      require: false,
      default: ""
    },
    proxySelfClick: {
      type: Function,
      require: false,
      default: null
    },
    proxyEnterClick: {
      type: Function,
      require: false,
      default: null
    }
  },
  data() {
    return {
      dataPriorityContactPassenger: this.priorityContactPassenger,
      dataPassengerMobile: this.passengerMobile,
      dataPassengerName: this.passengerName
    };
  },
  watch: {
    priorityContactPassenger() {
      this.dataPriorityContactPassenger = this.priorityContactPassenger;
    },
    passengerMobile() {
      this.dataPassengerMobile = this.passengerMobile;
    },
    passengerName() {
      this.dataPassengerName = this.passengerName;
    }
  },
  mounted() {},
  methods: {
    selfButtonClick() {
      if (this.proxySelfClick) {
        this.proxySelfClick();
      }
    },
    enterButtonClick() {
      if (this.proxyEnterClick) {
        this.proxyEnterClick(this.dataPriorityContactPassenger, this.dataPassengerMobile, this.dataPassengerName);
      }
    }
  }
};